import { css } from '@emotion/css'
import { colors, spacing } from '@offerzen/pinata'

const styles = {
  matchingListWrapper: css({
    display: 'grid',
    alignItems: 'flex-start',
    gridTemplateColumns: 'auto 1fr',
  }),

  commaList: css({
    display: 'inline',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    textTransform: 'lowercase',

    ':first-letter': {
      textTransform: 'uppercase',
    },

    li: {
      display: 'inline',
      color: colors.scorpion,
    },
  }),

  listMarker: css({
    paddingRight: spacing.small,
  }),
}

export default styles
